// Sound settings: master mute, volume, and per event a switch with a play
// button. Used by the Trenches Sound popover and the /test/sounds page.
import { PlayIcon } from '@phosphor-icons/react'
import { useSyncExternalStore } from 'react'
import { previewSound } from '../../lib/sound/engine'
import {
  SOUND_EVENTS,
  SOUND_EVENT_LABEL,
  type SoundSettings,
  readSoundSettings,
  subscribeSoundSettings,
  writeSoundSettings,
} from '../../lib/sound/settings'
import soft from '../../styles/soft.module.css'
import { SoftSlider, SoftSwitch } from '../ui/SoftControls'
import styles from './sound.module.css'

export function useSoundSettings(): SoundSettings {
  return useSyncExternalStore(subscribeSoundSettings, readSoundSettings, readSoundSettings)
}

export function SoundSettingsPanel() {
  const settings = useSoundSettings()
  const set = (patch: Partial<SoundSettings>) => writeSoundSettings({ ...settings, ...patch })
  return (
    <div className={styles.panel}>
      <div className={styles.row}>
        <span className={styles.label}>Sound</span>
        <SoftSwitch
          checked={!settings.muted}
          onChange={(on) => set({ muted: !on })}
          label="Sound"
        />
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Volume</span>
        <SoftSlider
          className={styles.slider}
          value={Math.round(settings.volume * 100)}
          min={0}
          max={100}
          step={5}
          label="Volume"
          valueText={`${Math.round(settings.volume * 100)}%`}
          disabled={settings.muted}
          onChange={(v) => set({ volume: v / 100 })}
        />
      </div>
      <div className={styles.rule} />
      {SOUND_EVENTS.map((event) => (
        <div key={event} className={styles.row}>
          <button
            type="button"
            className={`${soft.btn} ${soft.round} ${soft.small} ${styles.play}`}
            aria-label={`Play ${SOUND_EVENT_LABEL[event]}`}
            onClick={() => previewSound(event)}
          >
            <PlayIcon size={12} weight="fill" />
          </button>
          <span className={styles.label}>{SOUND_EVENT_LABEL[event]}</span>
          <SoftSwitch
            checked={settings.enabled[event]}
            disabled={settings.muted}
            onChange={(on) => set({ enabled: { ...settings.enabled, [event]: on } })}
            label={SOUND_EVENT_LABEL[event]}
          />
        </div>
      ))}
    </div>
  )
}
